import React from 'react';
import { Link as RouterLink } from 'react-router-dom'; // eslint-disable-line no-restricted-imports
import { default as StyledLink } from 'tidee-life-ui/dist/src/link.js';
import { TMarginPaddingValues } from 'tidee-life-theme/dist/src/utils/index';

type BaseLinkProps = {
    as?: React.ElementType;
    children?: React.ReactNode;
    color?: string;
    display?: string;
    onClick?: () => void;
    padding?: TMarginPaddingValues | string;
    to?: string;
    underline?: boolean;
    'data-testid'?: string;
    [key: string]: any;
};

export const Anchor = (props: BaseLinkProps) => <Link {...props} />;

export const Link = (props: BaseLinkProps) => (
    <StyledLink as={RouterLink as any} {...(props as any)} />
);
